import api from "@/lib/api";
import { toast } from "sonner";
import { formatApiError } from "@/lib/format";

const loadScript = (src) =>
  new Promise((res) => {
    if (document.querySelector(`script[src="${src}"]`)) return res(true);
    const s = document.createElement("script");
    s.src = src;
    s.onload = () => res(true);
    s.onerror = () => res(false);
    document.body.appendChild(s);
  });

export async function payWithRazorpay({ purpose, amount_inr, campaign_id, user, onSuccess, description }) {
  try {
    const { data: order } = await api.post("/payments/orders", {
      purpose,
      amount_inr,
      campaign_id: campaign_id || null,
    });
    const doVerify = async ({ razorpay_order_id, razorpay_payment_id, razorpay_signature }) => {
      await api.post("/payments/verify", {
        razorpay_order_id,
        razorpay_payment_id,
        razorpay_signature,
      });
      toast.success("Payment confirmed");
      onSuccess?.();
    };

    if (order.test_mode_mocked) {
      // Mocked flow — simulate a successful payment in-browser.
      toast.message("Running in TEST-MODE-MOCKED · no real charge");
      await doVerify({
        razorpay_order_id: order.order_id,
        razorpay_payment_id: `pay_MOCK_${Math.random().toString(36).slice(2, 12)}`,
        razorpay_signature: `MOCK-${order.order_id}`,
      });
      return;
    }

    const ok = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
    if (!ok) throw new Error("Razorpay failed to load");

    const rzp = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      name: "Mirrorloops",
      description: description || purpose,
      order_id: order.order_id,
      prefill: user ? { name: user.name, email: user.email, contact: user.phone } : undefined,
      theme: { color: "#D4B878" },
      handler: doVerify,
      modal: {
        ondismiss: () => toast.message("Payment cancelled"),
      },
    });
    rzp.open();
  } catch (e) {
    toast.error(formatApiError(e));
  }
}
